var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_GB/internet/index.js
 ** module id = 404
 ** module chunks = 0
 **/